import logo from './logo.svg';
import './App.css';
import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from './pages/header/header';
import HomePage from './pages/main/home';
import FooterPage from './pages/footer/footer';
import AboutPage from './pages/main/about';
import TrainingDetailPage from './pages/main/training-detail';
import ProgramPage from './pages/main/program';
import FacilitatorCard from './pages/main/facilitator';
import ProfileGrid from './pages/main/team';
import TrainingPage from './pages/main/training';
import SareePage from './pages/main/saree';
import SareeDetailPage from './pages/main/saree-detail';
import TeamDetailPage from './pages/main/team-details';
import MyAccountPage from './pages/main/myaccount';
import CheckoutPage from './pages/main/checkout';
import CartPage from './pages/main/cart';
import LoginPage from './pages/main/login';
import RegisterPage from './pages/main/register';
import ContactPage from './pages/main/contact';
import FacilitatorDetailPage from './pages/main/facilitator-detail';
import ProtectedRoute from "./pages/ProtectedRoute";
import EmailVerify from './pages/main/verify';
import PaymentSuccess from './pages/main/paymentSuccess';
import CourseInvoice from './pages/main/invoice';
import Podcost from './pages/main/podcost';
import CalendarPage from './pages/main/calendar';
import CourseCalendar from './pages/main/calendarone';
import CorporateForm from './pages/main/corporateForm';
import TermsPage from './pages/main/terms';
import PrivacyPage from './pages/main/privacy';
import { useTranslation } from './context/TranslationContext';
// import LanguageSwitcher from './components/LanguageSwitcher';

import DhotiPage from './pages/main/dhoti';
import DhotiDetailPage from './pages/main/dhoti-detail';
import KidsPage from './pages/main/kids';
import KidsDetailPage from './pages/main/kids-detail';

import ShippingPolicy from './pages/main/shippingPolicy';
import ReturnRefundPolicy from './pages/main/returnRefundPolicy';
import CancellationPolicy from './pages/main/cancellationPolicy';
import FAQ from './pages/main/faq';
import SareeCareGuide from './pages/main/sareeCareGuide';
import BlogPage from './pages/main/blog';
import BlogDetailPage from './pages/main/blog-detail';

function App() {
  const { translateSync, currentLanguage } = useTranslation();

  useEffect(() => {
    const handleGlobalClick = (e) => {
      const anchor = e.target.closest('a');
      if (!anchor) return;

      const href = anchor.getAttribute('href') || '';

      // Contact click (email or phone)
      if (href.startsWith('mailto:') || href.startsWith('tel:')) {
        const contactType = href.startsWith('mailto:') ? 'email' : 'phone';
        if (window.gtag) {
          window.gtag('event', 'contact_click', {
            contact_type: contactType,
            page_location: window.location.href
          });
        }
      }

      // WhatsApp click
      if (href.includes('wa.me') || href.includes('whatsapp.com')) {
        // Let the local handler in saree-detail.js handle it if on product details
        if (window.location.pathname.includes('/saree/')) {
          return;
        }
        if (window.gtag) {
          window.gtag('event', 'whatsapp_click', {
            page_location: window.location.href,
            product_id: null,
            product_name: null
          });
        }
      }
    };

    document.addEventListener('click', handleGlobalClick);
    return () => document.removeEventListener('click', handleGlobalClick);
  }, []);

  // const location = useLocation();
  // const isVerifyRoute = location.pathname.startsWith('/verify/');
  return (
    <div className="App">

      {/* <BrowserRouter> */}
      <ToastContainer />

      <Header />
      {/* <LanguageSwitcher /> */}
      <Routes>
        <Route exact path='/' element={<HomePage />} />
        <Route exact path='/payment-success' element={<PaymentSuccess />} />
        <Route exact path='/login' element={<LoginPage />} />
        <Route exact path='/register' element={<RegisterPage />} />
        <Route exact path='/contact' element={<ContactPage />} />
        <Route exact path='/corporate' element={<CorporateForm />} />
        <Route exact path="/terms" element={<TermsPage />} />
        <Route exact path="/privacy" element={<PrivacyPage />} />
        <Route exact path="/shipping-policy" element={<ShippingPolicy />} />
        <Route exact path="/return-refund-policy" element={<ReturnRefundPolicy />} />
        <Route exact path="/cancellation-policy" element={<CancellationPolicy />} />
        <Route exact path="/faq" element={<FAQ />} />
        <Route exact path="/saree-care-guide" element={<SareeCareGuide />} />
        <Route exact path="/blog" element={<BlogPage />} />
        <Route exact path="/blog/:slug" element={<BlogDetailPage />} />

        <Route path='/about' element={<AboutPage />} />
        <Route path='/saree' element={<SareePage />} />
        <Route path='/dhoti' element={<DhotiPage />} />
        <Route path='/facilitator' element={<FacilitatorCard />} />
        <Route path='/facilitator-detail/:slug' element={<FacilitatorDetailPage />} />
        <Route path='/saree/:id' element={<SareeDetailPage />} />
        <Route path='/dhoti/:id' element={<DhotiDetailPage />} />
        <Route path='/kids' element={<KidsPage />} />
        <Route path='/kids/:id' element={<KidsDetailPage />} />
        <Route path='/facilitator' element={<FacilitatorCard />} />
        <Route path='/team' element={<ProfileGrid />} />
        <Route path='/training/:id' element={<TrainingPage />} />
        {/* <Route path='/podcast' element={<PodcastPage />} /> */}
        <Route path='/training-detail/:courseId' element={<TrainingDetailPage />} />
        <Route path='/team-details/:slug' element={<TeamDetailPage />} />
        <Route exact path='/contact' element={<ContactPage />} />
        <Route path='/verify/:token' element={<EmailVerify />} />

        <Route exact path='/invoice/:id' element={<CourseInvoice />} />

        <Route exact path='/podcast' element={<Podcost />} />

        <Route exact path='/calendar' element={<CalendarPage />} />

        <Route exact path='/calendarone' element={<CourseCalendar />} />

        {/* <Route exact path='/podcast' element={<ContactPage />} />
           */}


        {/* <Route path='/training' element={<ProtectedRoute element={<TrainingPage />} />} /> */}
        <Route path='/cart' element={<CartPage />} />
        <Route exact path="/myaccount" element={<ProtectedRoute element={<MyAccountPage />} />} />
        <Route exact path="/checkout" element={<ProtectedRoute element={<CheckoutPage />} />} />


      </Routes>
      <FooterPage />
      {/* </BrowserRouter> */}
    </div>
  );
}

export default App;
